const body = document.querySelector('body');
const banner = document.querySelector('section.hero');
const menuTrigger = document.querySelector('button.menu-toggle');
const desktopCta = document.querySelector('div.desktop-fixed-cta');

function updateMenuTrigger() {
    const bannerBottomPosition = banner ? banner.offsetHeight : 400;
    let scrollPosition = window.pageYOffset;

    // console.log(bannerBottomPosition, scrollPosition);

    if (menuTrigger) {
        if (scrollPosition > bannerBottomPosition) {
            body.classList.add('sticky-menu');

            if(desktopCta){
                desktopCta.classList.add('show');
            }
        } else {
            body.classList.remove('sticky-menu');

            if(desktopCta){
                desktopCta.classList.remove('show');
            }
        }
    }
}

// Throttle function to improve performance
function throttle(fn, wait) {
    let lastTime = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastTime >= wait) {
            fn(...args);
            lastTime = now;
        }
    };
}

['resize', 'scroll'].forEach(event => {
    window.addEventListener(event, throttle(updateMenuTrigger, 20));
});